module.exports = __webpack_public_path__ + "img/027.5952d316.jpg";